import React, { Component } from 'react'
import { Row, Col, Divider, Table, Button, Spin, Input } from 'antd'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import common from '../../public/common'
import { getParmUrl, getCookie } from '../../public/utils'
import './index.less'
import moment from 'moment'
import BuyOrderDetails from '../orderAdmin/buyOrderDetails'
const { TextArea } = Input
class ReportPrint extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            spin: false,
            infoData: {},
            batchData: []
        }
    }
    componentDidMount() {
        this.getDetails()
        this.getList()
    }
    // 获取打印详情
    getDetails = () => {
        this.setState({
            spin: true
        })
        ajaxApi({
            url: common.SapUrl + 'difference/supplier/report/detail',
            params: {
                sid: getCookie('userName'),
                id: getParmUrl('id')
            } 
        }).then(res => {
            if (res) {
                this.setState({
                    spin: false,
                    infoData: res.data
                })
            } else {
                this.setState({
                    spin: false
                })
            }
        }) 
    }
    getList = () => {
      ajaxApi({
        url: common.SapUrl + '/difference/supplier/report/batch/detail',
        params: {
            sid: getCookie('userName'),
            id: getParmUrl('id')
        }
      }).then(res => {
          if (res) {
              this.setState({
                  batchData: res.data.difference_report_batch_details
              })
          }
      })
    }
    print = () => {
        window.document.body.innerHTML = window.document.getElementsByClassName('printBody')[0].innerHTML;  
        window.print()
        window.location.reload()
    }
    render() {
        const { spin, infoData, batchData } = this.state
        const columns = [
            {
                title: '是否差异',
                align: 'center',
                dataIndex: 'different',
                render: (text) => (
                    <span>{text === true ? '有' : '无'}</span>
                )
            },
            {
                title: '货品编码',
                align: 'center',
                dataIndex: 'product_code',
                width: '12%'
            },
            {
                title: '货品名称',
                align: 'center',
                dataIndex: 'product_name',
                width: '24%'
            },
            {
                title: '批号',
                align: 'center',
                dataIndex: 'batch_number',
                width: '8%'
            },
            {
                title: '生产日期',
                align: 'center',
                dataIndex: 'producation_date',
                width: '11%'
            },
            {
                title: '失效日期',
                align: 'center',
                dataIndex: 'expiry_date',
                width: '11%'
            },
            {
                title: '供应商发货',
                align: 'center',
                dataIndex: 'delivery_code',
                width: '11%'
            },
            {
                title: '收货-合格',
                align: 'center',
                dataIndex: 'qualified_number',
                width: '11%'
            },
            {
                title: '收货-不合格',
                align: 'center',
                dataIndex: 'unqualified_number',
                width: '12%'
            }
        ]
        return(<div className="differcen">
            <Spin spinning={spin}>
            <div className="search">
                <Button type="primary" shape="round" onClick={this.print}>打印</Button>
                <Button shape="round" style={{marginLeft: '10px'}} onClick={() => {this.props.history.go(-1)}}>返回</Button>
                <div className="printBody">
                  <h3 style={{textAlign: 'center',fontSize: '18px'}}>视客仓库收货报告</h3>
                  <Row>
                      <Col span={8}>
                           <label>差异单号：</label>
                           <span>{infoData.difference_code}</span>
                      </Col>
                      <Col span={8}>
                           <label>供应商：</label>
                           <span>{infoData.supplier_name}</span>
                      </Col>
                      <Col span={8}>
                           <label>仓库：</label>
                           <span>{infoData.whid_name}</span>
                      </Col>
                  </Row>
                  <Row style={{marginTop: '10px'}}>
                      <Col span={6}>
                          <label>是否差异：</label>
                          <span>{infoData.different === true ? '有' : '无'}</span>
                      </Col>
                      <Col span={8}>
                           <label>报告时间：</label>
                           <span>{infoData.gmt_create && moment(infoData.gmt_create).format('YYYY-MM-DD HH:mm:ss')}</span>
                      </Col>
                      <Col span={8}>
                           <label>报告人：</label>
                           <span>{infoData.reporter_name}</span>
                      </Col>
                  </Row>
                  <Divider/>
                  <Row>
                      <Col span={8}>
                           <label>来货单号：</label>
                           <span>{infoData.delivery_code}</span>
                      </Col>
                      <Col span={8}>
                           <label>发货单号：</label>
                           <span>{infoData.supplier_delivery_code}</span>
                      </Col>
                      <Col span={8}>
                           <label>外部单号：</label>
                           <span>{infoData.link_order_number}</span>
                      </Col>
                  </Row>
                  <Divider/>
                  {
                    infoData.difference_report_purchaser_details && infoData.difference_report_purchaser_details.map(item => {
                        return  <Row>
                                    {/* <Col span={6}>
                                        <label>采购单：</label>
                                        <a>{item.po_code}</a>
                                    </Col> */}
                                    <Col span={8}>
                                        <label>采购员：</label>
                                        <span>{item.purchaser_name}</span>
                                    </Col>
                                    <Col span={8}>
                                        <label>联系方式：</label>
                                        <span>{infoData.purchaser_phone}</span>
                                    </Col>
                                </Row>
                    })
                }
                  <Row style={{marginTop: '10px'}}>
                      <Col span={8}>
                           <label>退货地址：</label>
                           <span>{infoData.return_address}</span>
                      </Col>
                      <Col span={8}>
                           <label>退货联系人：</label>
                           <span>{infoData.return_contacts}</span>
                      </Col>
                      <Col span={8}>
                           <label>联系方式：</label>
                           <span>{infoData.return_contacts_phone}</span>
                      </Col>
                  </Row>
                  <Row style={{marginTop: '10px'}}>
                      <Col span={8}>
                           <label>物流公司：</label>
                           <span>{infoData.return_logistics_name}</span>
                      </Col>
                      <Col span={8}>
                           <label>物流单号：</label>
                           <span>{infoData.return_logistics_numbers}</span>
                      </Col>
                  </Row>
                  <Row style={{marginTop: '10px', marginBottom: '15px'}}>
                      <Col span={24} style={{display: 'inherit'}}>
                          <label>备注：</label>
                          <TextArea style={{width: '80%'}} value={infoData.remark}/>
                      </Col>
                  </Row>
                  <Table columns={columns} dataSource={batchData} pagination={false}/>
                  <div style={{marginTop: '15px'}}>
                      <span>合计：</span>
                      <span>异常货品种类：</span>
                      <span style={{color: '#f00'}}>{infoData.total_abnormal_number}</span>
                      <span style={{marginLeft: '15px'}}>供应商发货：</span>
                      <span style={{color: '#f00'}}>{infoData.total_delivery_number}</span>
                      <span style={{marginLeft: '15px'}}>收货-合格：</span>
                      <span style={{color: '#f00'}}>{infoData.total_qalified_number}</span>
                      <span style={{marginLeft: '15px'}}>收货-不合格：</span>
                      <span style={{color: '#f00'}}>{infoData.total_unqualified_number}</span>
                  </div>
                </div>
            </div>
            </Spin>
        </div>)
    }
}
export default ReportPrint


// WEBPACK FOOTER //
// ./src/pages/differReport/reportPrint.js